<p class="small task d-flex justify-content-between mb-1" [ngClass]="labelClass" *ngIf="label">
  <span>{{ label }}</span> /
  <span class="bold percent">{{ max | number: '2.0' }}{{ suffix }}</span>
</p>
<progressbar [value]="value" [class]="size" [type]="color" [max]="max"></progressbar>
